export enum ImportItemStatus {
    Created = 'STATUS_CREATED',
    Failed = 'STATUS_FAILED',
    Published = 'STATUS_PUBLISHED',
    Warning = 'STATUS_WARNING',
    Publishing = 'STATUS_PUBLISHING',
    NotPublished = 'STATUS_NOT_PUBLISHED',
    ReadyToPublish = 'STATUS_READY_TO_PUBLISH',
    Receiving = 'STATUS_RECEIVING',
}
